import React from "react";
import { useQuery } from "@tanstack/react-query";
import { reportService } from "../../services/reports";
import LoadingSpinner from "../Common/LoadingSpinner";

export default function TaxReport({ dateRange }) {
  const { data, isLoading } = useQuery({
    queryKey: ["tax-report", dateRange],
    queryFn: () => reportService.getTaxReport(dateRange)
  });

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <h3 className="text-lg font-semibold mb-4">Tax Report (VAT)</h3>
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-blue-50 p-3 rounded">
            <p className="text-sm">Total VAT Collected</p>
            <p className="text-xl font-bold">KES {data?.summary?.totalVATCollected?.toLocaleString() || 0}</p>
          </div>
          <div className="bg-green-50 p-3 rounded">
            <p className="text-sm">Total VAT Payable</p>
            <p className="text-xl font-bold">KES {data?.summary?.totalVATPayable?.toLocaleString() || 0}</p>
          </div>
        </div>
      </div>
    </div>
  );
}